import { Injectable } from '@angular/core';
import { Observable, Subscription, BehaviorSubject } from 'rxjs';
import { MsalService } from '@azure/msal-angular';
import { isIE, b2cPolicies, environment, msalConfig } from '../../environments/environment';
import { User } from '../model/user';
import { StorageService } from './storage.service';
import { ConstantService } from '../constant/constant-service';
import { TransactionService } from './transaction.service';
import { TransactionPrevImpService } from './transaction-prev-imp.service';
import { InteractionRequiredAuthError } from 'msal';

@Injectable({
  providedIn: 'root'
})

export class AuthService {
  subscriptions: Subscription[] = [];
  isIframe = false;
  loggedIn = false;

  private readonly currentUserSubject: BehaviorSubject<User>;
  private readonly cacheableEndpoints = [
    '/IntoMawbp/getQueryDepartamento',
    '/IntoMawbp/getQueryCity',
    '/IntoMawbp/getQueryTipoDocumento',
    '/IntoMawbp/getQueryPais',
    '/IntoMawbp/getValidateCodeAirline',
    '/IntoMawbp/getQueryTipoDocumentoViaje',
    '/IntoMawbp/getQueryAerolinea',
    '/IntoMawbp/getQueryTipoCliente',
    '/IntoMawbp/getQueryBuscarOtrosDatosDIAN',
    '/IntoMawbp/getQueryBaseAdministracion',
    '/IntoMawbp/getQueryDisposicionCarga'
  ];

  public currentUser: Observable<User>;
  public requestUser: User;

  constructor(private readonly authService: MsalService, private readonly transactionService: TransactionService, 
    private readonly constantService: ConstantService, private readonly storageService: StorageService, 
    private readonly impService: TransactionPrevImpService) {
    const data = this.storageService.getSessionStorageItem(this.constantService.SESSION_STORAGE_USER);
    this.currentUserSubject = new BehaviorSubject<User>(data);
    if (data != null) {
      this.currentUser = this.currentUserSubject.asObservable();
    }
  }

  public get currentUserValue(): User {
    return this.currentUserSubject ? this.currentUserSubject.value : null;
  }

  checkAccount() {
    let user = this.authService.getAccount();
    this.loggedIn = !!user;
    if (this.loggedIn) {
      this.authorization(user.idToken.emails[0]);
    }
  }

  getAccount() {
    return this.authService.getAccount();
  }

  login() {
    if (isIE) {
      this.authService.loginRedirect();
    } else {
      this.authService.loginPopup();
    }
  }

  authorization(mail: string) {
    this.transactionService.getAll(environment.adminAPI, this.constantService.USER_URL + '/mail/' + mail).subscribe(
      (data) => {
        if (data.responseDto.response === this.constantService.RESPONSE_OK) {
          this.requestUser = data.businessDto[0];
          this.storageService.setSessionStorageItem(this.constantService.SESSION_STORAGE_USER, JSON.stringify(this.requestUser));
        }
        this.currentUserSubject.next(this.requestUser);
        this.currentUser = this.currentUserSubject.asObservable();
      },
      (error) => {
        console.log('Error: ' + error);
      }
    );
  }

  private removeCacheableKeys(): void {
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const key = localStorage.key(i);
      if (key && this.cacheableEndpoints.some(endpoint => key.includes(endpoint))) {
        localStorage.removeItem(key);
      }
    }
  }

  logout() {
    sessionStorage.removeItem(this.constantService.SESSION_STORAGE_USER);
    this.currentUserSubject.next(null);
    this.authService.logout();
    this.storageService.remove('token');
    this.removeCacheableKeys();
  }

  editProfile() {
    if (isIE) {
      this.authService.loginRedirect(b2cPolicies.authorities.editProfile);
    } else {
      this.authService.loginPopup(b2cPolicies.authorities.editProfile);
    }
  }

  async getToken() {
    let response: string = "";
    response = await this.transactionService
      .getAll(environment.localApi, "/Auth").toPromise();
    return response;
  }

  async getTokenIBS() {
    let response: string = "";
    response = await this.transactionService
      .getAll(environment.localApi, "/Auth/ibs").toPromise();
    return response;
  }

  async getTokenAsync() {
    let request = {
      scopes: [msalConfig.auth.clientId],
      account: this.getAccount(),
      forceRefresh: true,
      refreshTokenExpirationOffsetSeconds: 3600 // 1 hours * 60 minutes * 60 seconds = 3600 seconds
    };

    await this.authService.acquireTokenSilent(request)
      .catch(async (error) => {
        if (error instanceof InteractionRequiredAuthError) {
          // fallback to interaction when silent call fails
          this.authService.acquireTokenRedirect(request);
        }
      });

  }

}
